import { DetailsSection } from "./DetailsSection";

const FarmCard = {
  DetailsSection,
};

export default FarmCard;
